/* eslint-disable import/prefer-default-export */
export const EVENT_TYPES = {
  stopGame: 'stopGame',
  swapEntities: 'swapEntities',
  onKeyDown: 'onKeyDown',
  onInputPadSend: 'onInputPadSend',
  onRecordPadSend: 'onRecordPadSend',
  yTPSC: 'youTubePlayerStateChange',
};
